<template>
	<div>
		<navpage ref="navPage" :middle="true" pagename="rules"></navpage>

		<div id="content-page">
			<div class="row dynvibeRow dynvibeSearchRules">
				<div class="col-lg-3">
					<button @click="add()" class="dynvibeButton" style="min-width: 200px">Add new mastertag</button>
					<br />
					<input
						@keyup="searchIn($event)"
						class="dynvibeInputText"
						type="text"
						v-model="search"
						placeholder="Search mastertags..."
					/>
				</div>
				<div class="col-lg-2">
					<button class="dynvibeButton" style="margin-left: 5px; border-radius: 12px; height: 25px" @click="onlyUnaffected()">
						Only unaffected
					</button>
					<br />
					<button class="dynvibeButton" style="margin-left: 5px; border-radius: 12px; height: 25px" @click="clear()">
						Clear all
					</button>
				</div>
				<div class="col-lg-3">
					<div id="mastertagsuploader" class="btn btn-primary">
						<i class="fas fa-folder"></i> Upload mastertags
						<input type="file" id="file" ref="file" title="Click to add Files" @change="submitFile()" />
					</div>
				</div>
			</div>
			<div class="row dynvibeRow" style="margin-top: 15px">
				<div class="col-xs-12">
					<listmtcat :type="type" :key="key" ref="listmtcat" @innerclick="innerlistClik"></listmtcat>
					<div v-if="show">
						<div class="col-lg-10">
							<div class="dynvibeListMastertagsRules">
								<div class="dynvibeBox" style="min-height: inherit; margin-top: 20px">
									<img class="img-circle" id="TwiPic" :src="imgUrl()" style="width: 100px; height: 100px" />
									<span @click="edit('imgurl')" class="dynvibeMastertagPhotoEdit" title="Edit Photo"
										><i class="fas fa-edit"></i
									></span>
									<p>
										<span style="text-transform: uppercase">Mastertag : </span>
										<span class="dynvibeMastertagName">{{ data.label }}</span>
										<span @click="edit('mastertag')" class="dynvibeMastertagNameEdit" title="Edit name">
											<i class="fas fa-edit"></i>
										</span>
									</p>
									<p>
										<span style="text-transform: uppercase">Twitter Account : </span>
										<span class="dynvibeMastertagTwitter">
											{{ data.twitteraccount }}
										</span>
										<span @click="edit('twitteraccount')" title="Edit Twitter Account">
											<i class="fas fa-edit"></i>
										</span>
									</p>
									<div style="margin-top: 15px">
										<span style="text-transform: uppercase">Tag class:</span>
										<select
											class="dynvibeSelect dynvibeMastertagType"
											style="min-width: 150px"
											@change="updateType(typemastertagSelected)"
											v-model="typemastertagSelected"
										>
											<option v-for="(type, index) in typemastertags" :key="index" :value="type">{{ type }}</option>
										</select>
									</div>
									<div style="margin-top: 15px">
										<span style="text-transform: uppercase">Subcategories</span>
										<select
											class="dynvibeSelect dynvibeMastertagAssign"
											style="min-width: 150px"
											v-model="subcateselected"
										>
											<option v-for="(subcat, index) in data.allsubcats" :key="index" :value="subcat">
												{{ subcat }}
											</option>
										</select>
										<span @click="addSubcategory(subcateselected)" class="dynvibeAddSubCategory icon-plus"></span>
									</div>
									<div class="dynvibeMastertagAssigned">
										<div class="dynvibeRuleTag" v-for="(subcat, index) in data.subcats" :key="index">
											<div>
												<span>{{ subcat }}</span>
												<i @click="removeSubcategory(subcat)" class="dynvibeRuleSepRemove icon-x"></i>
											</div>
										</div>
									</div>
									<div class="dynvibeMastertagRules">
										<span style="text-transform: uppercase">Rules</span>
										<button
											@click="addRow()"
											class="dynvibeButton"
											style="margin-left: 5px; border-radius: 12px; height: 25px"
										>
											Add new Rule
										</button>
									</div>
									<div v-if="data.rules !== undefined">
										<datatable ref="datatable" :data="data.rules" :headers="headers" :key="keydatatable">
											<template v-slot:cell="{ value: value }">{{ value.join(";") }} </template>
											<template v-slot:handle="{ indexrow: indexRow }">
												<span @click="deleteRow(indexRow)">
													<i class="far fa-trash-alt"></i>
												</span>
											</template>
										</datatable>
									</div>
									<div style="margin-top: 15px">
										<button @click="refreshData()" class="dynvibeButton" style="min-width: 100px; margin-right: 10px">
											Refresh
										</button>
										<p style="display: inline">
											<span class="dynvibeRuleAffectedPosts">
												{{ data.totalResults }}
											</span>
											posts affected by this rule.
										</p>
									</div>
									<div style="margin-top: 15px">
										<button @click="save()" class="dynvibeButton" style="min-width: 100px">Save</button>
										<button @click="Delete()" class="dynvibeButton" style="min-width: 100px; margin-left: 10px">
											Delete
										</button>
										<button @click="preview()" class="dynvibeButton" style="min-width: 100px; margin-left: 10px">
											Preview
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else-if="showMastertagsuploader">
						<div class="col-lg-10">
							<div class="dynvibeListMastertagsRules">
								<h3>CHECK SIMILAR MASTERTAGS</h3>
								<p>The selected words will not be added</p>
								<div class="dynvibeMastertagsReturnList" :data-fileurl="filename">
									<div v-for="(mastertags, id) in data.return" :key="id" class="col-lg-12">
										<h4>{{ id }}</h4>
										<input
											type="checkbox"
											class="dynvibeProfiles dynvibeStoryCheckbox"
											:value="id"
											v-model="checkedMastertags"
										/>
										<span v-for="(mastertag, id2) in mastertags" :key="id2">
											{{ mastertag }}
										</span>
									</div>
									<div style="clear: both"></div>
								</div>
								<button
									class="dynvibeButton"
									@click="mastertagsApplyList()"
									style="margin-left: 5px; border-radius: 12px; height: 25px"
								>
									UPDATE FILE
								</button>
								{{ filename }}
							</div>
						</div>
					</div>
					<div v-else-if="showMastertagConfirm">
						<div class="col-lg-10">
							<div class="dynvibeListMastertagsRules">
								<h3>RESULT OF ADDING MASTERTAGS</h3>
								<table class="table">
									<tr>
										<td v-for="(output, index) in data.outputresults" :key="index" class="col-lg-4">
											<table class="table">
												<thead>
													<tr>
														<td v-if="index == 'addedwithout'">ADDED WITHOUT VERIFICATION</td>
														<td v-else-if="index == 'addedwith'">ADDED WITH SIMILARITIES</td>
														<td v-else-if="index == 'notadded'">NOT ADDED</td>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(mastertag, id) in output" :key="id">
														<td>
															<p class="mastertagadded">{{ mastertag }}</p>
															<p class="rulesadded">{{ data.outputrulesresult[mastertag] }}</p>
														</td>
													</tr>
												</tbody>
											</table>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
				<transition name="modal">
					<div
						v-show="showModal"
						class="modal-mask"
						tabindex="-1"
						role="dialog"
						aria-hidden="true"
						style="display: block"
						@click="showModal = false"
					>
						<div class="modal-dialog modal-lg">
							<div class="modal-content" @click.stop>
								<div class="modal-header">
									<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0px">
										<h5 class="modal-title" id="dynvibeGraphDetailsTitle">
											<span class="dynvibeModalTitle">Graph details</span>
											<button
												type="button"
												@click="closeModal()"
												class="close"
												data-dismiss="modal"
												aria-label="Close"
												style="outline: 0"
											>
												<span aria-hidden="true">
													<i class="icon-x"></i>
												</span>
											</button>
										</h5>
									</div>
								</div>
								<div class="modal-body">
									<div
										v-if="data.resultsPosts && data.resultsPosts.length > 0"
										class="col-lg-12 dynvibeListPosts dynvibeBox"
										style="margin: 10px 0px"
									>
										<bigstory
											:showfiche="false"
											:ref="'story-' + post._id"
											v-for="post in data.resultsPosts"
											v-bind:key="post._id"
											:post="post"
											:middle="true"
										></bigstory>
									</div>
									<div v-else class="noData">No data to display</div>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>
			<confirm
				ref="confirminput"
				:color="confirmColor"
				:type="confirmType"
				:title="confirmTitle"
				@answerconfirm="treatConfirm($event)"
			>
				<template v-slot:confirm-body>
					{{ confirmMessage }}
					<div v-if="displayInput">
						<input v-model="inputValue" autofocus class="form-control" type="text" />
					</div>
					<div v-else-if="displayUpload">
						<input ref="displayUpload" autofocus class="form-control" formenctype="multipart/form-data" type="file" />
					</div>
				</template>
			</confirm>
			<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
				<template v-slot:confirm-body>{{ confirmMessage }}</template>
			</confirm>
		</div>
	</div>
</template>

<script>
let delay = (function () {
	let timer = 0;
	return function (callback, ms) {
		clearTimeout(timer);
		timer = setTimeout(callback, ms);
	};
})();

import navpage from "@/components/globalVue/Nav.vue";
import listmtcat from "@/components/globalVue/ListMtCatAdmin.vue";
import bigstory from "@/components/posts/bigStory.vue";
import datatable from "@/components/globalVue/datatable.vue";
import confirm from "@/components/globalVue/Confirm.vue";
export default {
	name: "rulesPage",
	data() {
		return {
			type: "mastertags",
			show: false,
			showModal: false,
			showMastertagsuploader: false,
			showMastertagConfirm: false,
			key: 0,
			data: {
				imgurl: "",
				resultsPosts: [],
			},
			search: "",
			subcateselected: "",
			typemastertags: ["activation", "brand", "tag"],
			typemastertagSelected: undefined,
			file: "",
			filename: "",
			checkedMastertags: [],
			inputValue: "",
			query: "",
			headers: ["group1", "group2", "language", "handle"],
			keydatatable: 0,
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			displayUpload: false,
			displayInput: false,
		};
	},
	watch: {
		data(newVal) {
			this.typemastertagSelected = this.data.typemastertag;
			this.data.rules = this.formatRules(newVal.rules);
		},
		inputValue(newVal) {
			this.inputValue = newVal;
		},
	},
	components: {
		navpage: navpage,
		listmtcat: listmtcat,
		bigstory: bigstory,
		datatable: datatable,
		confirm: confirm,
	},
	mounted() {
		this.$axios.interceptors.request.use(
			(config) => {
				return config;
			},
			(error) => {
				return Promise.reject(error);
			}
		);
		this.$axios.interceptors.response.use(
			(response) => {
				if (response.data.isOk) {
					this.$refs.confirm.close();
					this.key++;
				}
				return response;
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	methods: {
		treatConfirm(event) {
			this.displayUpload = false;

			if (event === "OK" && this.query !== "") {
				//this.$refs.confirminput.close();
				this.inputValue = this.inputValue.trim();
				if (this.inputValue.trim() != "" || this.$refs.displayUpload != undefined) {
					if (this.query == "addMastertag") {
						this.data.label = this.inputValue;
						this.$axios
							.post(this.$backendUrl + this.query, this.$Qs.stringify({ mastertag: this.data.label }))
							.then((response) => {
								if (response.data.isOk === true) {
									this.confirmSuccessModal("Mastertag " + this.data.label + " has been added.");
								} else {
									this.confirmErrorModal("This mastertag already exist.");
								}
								this.inputValue = "";
							})
							.catch(() => {
								this.confirmErrorModal("Mastertag " + this.data.label + "has not been edited.");
							});
						delay(() => {
							this.innerlistClik({
								label: this.data.label,
								type: this.type,
							});
						}, 3);
					} else if (this.query == "editNameMastertag") {
						if (this.inputValue != this.data.label) {
							this.$axios
								.post(
									this.$backendUrl + this.query,
									this.$Qs.stringify({
										oldmastertag: this.data.label,
										newmastertag: this.inputValue,
									})
								)
								.then((response) => {
									if (response.data.isOk) {
										this.confirmSuccessModal("Mastertag has been edited." + this.data.label + " =>" + this.inputValue);
										this.data.label = this.inputValue;
									} else {
										this.confirmErrorModal("Mastertag" + this.inputValue + "already exists.");
									}
									this.inputValue = "";
								})
								.catch(() => {
									this.confirmErrorModal("Mastertag" + this.data.label + "has not been edited.");
								});
						} else {
							this.confirmErrorModal("Mastertag" + this.data.label + "has not been edited.");
						}
					} else if (this.query == "editMastertagTwitteraccount") {
						this.$axios
							.post(
								this.$backendUrl + this.query,
								this.$Qs.stringify({
									mastertag: this.data.label,
									twitteraccount: this.inputValue,
								})
							)
							.then((response) => {
								if (response.data.isOk) {
									this.confirmSuccessModal(
										"Mastertag Twitter Account has been edited. " + this.data.twitteraccount + "=>" + this.inputValue
									);
									//image should be refreshed
									this.data.twitteraccount = this.inputValue;
								}
								this.inputValue = "";
							})
							.catch(() => {
								this.confirmErrorModal("Mastertag '" + this.data.twitteraccount + " has not been edited.");
							});
					} else if (this.query == "editMastertagImg") {
						if (this.$refs.displayUpload != null) {
							let image = this.$refs.displayUpload.files[0];
							const data = new FormData();
							data.append("image", image);
							data.append("mastertag", this.data.label);
							this.$axios
								.post(this.$backendUrl + this.query, data)
								.then((response) => {
									if (response.data.isOk) {
										this.data.imgurl = image.name;
										this.confirmSuccessModal("Mastertag Image has been edited. " + this.data.label);
									} else {
										this.confirmErrorModal("Mastertag Image " + this.data.label + "has not been edited.");
									}
								})
								.catch(() => {
									this.confirmErrorModal("Mastertag Image " + this.data.label + " has not been edited.");
								});
						}
					}
				} else if (this.query === "updateMastertag") {
					let rules = this.$refs.datatable.getData();
					if (rules["error"]) {
						this.confirmErrorModal(rules["error"]);
					} else {
						this.$axios
							.post(
								this.$backendUrl + "updateMastertag",
								this.$Qs.stringify({
									rules: rules,
									imgurl: this.data.imgurl,
									mastertag: this.data.label,
									subcategories: this.data.subcats,
									twitteraccount: this.data.twitteraccount,
									typemastertag: this.data.typemastertag,
								}),
								{
									Accept: "application/json",
									"Content-Type": "application/json",
								}
							)
							.then((response) => {
								if (response.data.isOk) {
									this.confirmSuccessModal("Mastertag " + this.data.label + " has been edited.");
								} else {
									this.confirmErrorModal("Mastertag " + this.data.label + " has not been edited.");
								}
							});
					}
				} else if (this.query === "deleteMastertag") {
					this.$axios
						.post(
							this.$backendUrl + "deleteMastertag",
							this.$Qs.stringify({
								mastertag: this.data.label,
							}),
							{
								Accept: "application/json",
								"Content-Type": "application/json",
							}
						)
						.then((response) => {
							if (response.data.isOk) {
								this.show = false;
								this.confirmSuccessModal("Mastertag " + this.data.label + " has been deleted.");
							} else {
								this.confirmErrorModal("Mastertag " + this.data.label + " has not been deleted.");
							}
						});
				} else if (this.query.includes("deleteRule_")) {
					this.$refs.datatable.deleteRow(this.query.split("_")[1]);
				} else {
					this.confirmErrorModal("Mastertag name must be given");
					return false;
				}
			}
		},
		mastertagsApplyList() {
			this.query = "fileupload";
			let mastertagsDoNotSave = this.checkedMastertags;
			let mastertagsAllSave = [];
			for (const mastertag in this.data.return) {
				mastertagsAllSave.push(mastertag);
			}
			this.$axios
				.post(
					this.$backendUrl + this.query,
					this.$Qs.stringify({
						filename: this.filename,
						mastertagsDoNotSave: mastertagsDoNotSave,
						mastertagsAllSave: mastertagsAllSave,
						idUploader: "mastertagsuploader",
						ajax: true,
					})
				)
				.then((response) => {
					this.data = response.data;
					(this.show = false),
						(this.showModal = false),
						(this.showMastertagsuploader = false),
						(this.showMastertagConfirm = true);
					if (response.data.error != "") {
						this.confirmErrorModal(response.data.error);
					} else {
						this.confirmSuccessModal("File has been added.");
					}
				})
				.catch(() => {
					this.confirmErrorModal("File has not been added. Contact the fantastic developers :)");
				});
		},
		deleteRow(index) {
			this.confirmInputDeleteModal("Are you sure to delete this rule ?");
			this.displayInput = false;
			this.query = "deleteRule_" + index;
			this.$refs.confirminput.open();
		},
		submitFile() {
			this.query = "fileupload";
			this.file = this.$refs.file.files[0];
			if (!/(\.csv)$/i.exec(this.file.name)) {
				this.confirmErrorModal("FAIL : Only csv file is authorized");
				return false;
			}
			let formData = new FormData();
			formData.append("fileupload", this.file);
			formData.append("idUploader", "mastertagsuploader");

			this.$axios
				.post(this.$backendUrl + this.query, formData, {
					headers: {
						"Content-Type": "text/csv",
						Accept: "text/csv",
					},
				})
				.then((response) => {
					if (response.data.error != "") {
						this.data.return = response.data.return;
						this.filename = response.data.filename;
						this.responseAlert(response.data.error, "error");
						this.show = false;
						this.showModal = false;
						if (response.data.showMastertagsuploader) {
							this.showMastertagsuploader = true;
						}
					} else {
						this.confirmErrorModal("File has been added.");
					}
				})
				.catch(() => {
					this.confirmErrorModal("File has not been added. Contact the fantastic developers :)");
				});
		},
		responseAlert(message, status) {
			this.displayInput = false;
			this.displayUpload = false;
			if (status == "error") {
				this.confirmErrorModal(message);
			} else {
				this.confirmSuccessModal(message);
			}
			this.$refs.confirminput.open();
		},
		add() {
			this.confirmInputAddModal("Enter mastertag name");
			this.confirmTitle = "Add mastertag";
			this.displayInput = true;
			this.query = "addMastertag";
			this.$refs.confirminput.open();
		},
		addSubcategory() {
			this.data.subcats.indexOf(this.subcateselected) === -1
				? this.data.subcats.push(this.subcateselected)
				: this.confirmErrorModal("This item already exists");
		},
		removeSubcategory(subcat) {
			let index = this.data.subcats.indexOf(subcat);
			index != -1 ? this.data.subcats.splice(index, 1) : this.confirmErrorModal("This item doesnt exist");
		},
		updateType(typemastertagSelected) {
			this.data.typemastertag = typemastertagSelected;
		},
		searchIn(event) {
			this.query = "search";
			this.$refs.listmtcat.search(event.target.value);
		},
		refreshData() {
			this.query = "getMastertag";
			let rules = this.$refs.datatable.getData();

			if (rules.length > 0) {
				this.$axios.post(this.$backendUrl + "postsMastertagged", this.$Qs.stringify({ rules: rules })).then((response) => {
					this.data.totalResults = response.data.totalResults;
				});
			}
		},
		addRow() {
			this.$refs.datatable.addRow();
		},
		innerlistClik(value) {
			this.keydatatable++;
			this.query = "getMastertag";
			this.getData("getMastertag", value);
			this.show = true;
		},
		treatResponse(response) {
			if (response.data.deleted === true) {
				return false;
			}
			if (response.data.resultsPosts != undefined) {
				this.data.resultsPosts = response.data.resultsPosts;
				this.showModal = true;
			} else {
				this.data = response.data;
				this.data.resultsPosts = [];
			}
			if (this.data.allsubcats != undefined) {
				this.subcateselected = this.data.allsubcats[0];
			}
		},
		clear() {
			this.$refs.listmtcat.unaffected = false;
			this.key++;
			this.search = "";
			this.show = false;
		},
		edit(type) {
			this.displayInput = true;
			this.displayUpload = false;

			if (type == "mastertag") {
				this.confirmInputAddModal("Enter mastertag name");
				this.query = "editNameMastertag";
				this.inputValue = this.data.label;
				this.$refs.confirminput.open();
			} else if (type == "twitteraccount") {
				this.confirmInputAddModal("Enter mastertag Twitter Account");
				this.query = "editMastertagTwitteraccount";
				this.inputValue = this.data.twitteraccount;
				this.$refs.confirminput.open();
			} else if (type == "imgurl") {
				this.confirmInputAddModal("Upload mastertag image");
				this.confirmTitle = "Upload mastertag";
				this.displayInput = false;
				this.displayUpload = true;
				this.query = "editMastertagImg";
				this.$refs.confirminput.open();
			}
		},
		onlyUnaffected() {
			this.$refs.listmtcat.unaffectedOnly();
		},
		launchMastertaguing() {
			this.$axios.get(this.$backendUrl + "manualMastertaging").then((response) => {
				if (response.data.isOk) {
					this.confirmSuccessModal("Manual mastertaguing launched with success");
				} else {
					this.confirmErrorModal("Something is wrong contact IT team");
				}
			});
		},
		save() {
			// updateMastertag
			this.confirmInputAddModal("Are you sure to edit this mastertag " + this.data.label + " ?");
			this.displayInput = false;
			this.query = "updateMastertag";
			this.$refs.confirminput.open();
		},
		Delete() {
			//deleteCategories
			this.confirmInputDeleteModal("Are you sure to delete mastertag: " + this.data.label + "? ");
			this.displayInput = false;
			this.query = "deleteMastertag";
			this.$refs.confirminput.open();
		},
		preview() {
			this.query = "postsMastertaggedView";
			let rules = this.$refs.datatable.getData();
			this.data.resultsPosts = [];

			if (rules.length > 0) {
				this.$axios.post(this.$backendUrl + "postsMastertaggedView", this.$Qs.stringify({ rules: rules })).then((response) => {
					this.data.resultsPosts = response.data.resultsPosts;
					if (this.data.resultsPosts) {
						this.showModal = true;
					}
				});
			}
		},
		formatRules(rules) {
			let out = [];
			if (typeof rules !== "undefined") {
				rules.forEach((v) => {
					if (v["rule"].length == 1) {
						out.push([v["rule"][0], [], v["lang"]]);
					} else {
						out.push([v["rule"][0], v["rule"][1], v["lang"]]);
					}
				});
			}

			return out;
		},
		closeModal() {
			this.showModal = false;
		},
		imgUrl() {
			if (typeof this.data.imgurl !== "undefined") {
				if (this.data.imgurl.length == 0) {
					return "https://avatars.io/twitter/" + this.data.twitteraccount + "/medium";
				} else {
					return "/img/twitterPics/" + this.data.imgurl;
				}
			}
			return "";
		},
	},
};
</script>

<style scoped>
.dynvibeSearchRules #mastertagsuploader {
	display: block;
	text-align: center;
	margin: 1px auto;
	width: 170px;
}

.dynvibeSearchRules #mastertagsuploader {
	margin: 1px 0;
	width: 177px;
}

.dynvibeSearchRules #mastertagsuploader.fileuploader {
	position: relative;
	overflow: hidden;
	cursor: pointer;
}

.dynvibeSearchRules #mastertagsuploader input[type="file"] {
	position: absolute;
	top: 0;
	right: 0;
	margin: 0;
	border: solid transparent;
	width: 100%;
	opacity: 0;
	cursor: pointer;
	height: 32px;
}

.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.dynvibeListMastertagsRules td {
	line-break: anywhere !important;
	float: left !important;
}
.dynvibeMastertagName {
	font-weight: bold;
}
.dynvibeMastertagRules {
	margin: 20px 0;
}
</style>
